import axiosClient from "./axiosClient";
import API_ENDPOINTS from "../constants/apiEndpoints";

function extractMessage(error, fallback) {
  const d = error?.response?.data;
  const inner = d?.data;
  return (
    inner?.reason ||
    inner?.message ||
    d?.reason ||
    d?.message ||
    error?.message ||
    fallback
  );
}

/**
 * Consumer contact form submission.
 *
 * Expected backend payload (JSON or FormData — switch via `asFormData`):
 * {
 *   full_name: string,       // required
 *   company: string,         // optional
 *   email: string,           // required
 *   phone: string,           // required — phone or WhatsApp
 *   interest: string,        // required — selected interest chip
 *   interest_other: string,  // required when interest === "Other"
 *   message: string,         // required
 *   source: "consumer_contact_page",
 *   contact_mode: "message" | "book"
 * }
 */
export async function submitContactForm(payload, { asFormData = true } = {}) {
  const body = {
    full_name: payload.fullName?.trim() || "",
    company: payload.company?.trim() || "",
    email: payload.email?.trim() || "",
    phone: payload.phone?.trim() || "",
    interest: payload.interest?.trim() || "",
    interest_other: payload.interestOther?.trim() || "",
    message: payload.message?.trim() || "",
    source: payload.source || "consumer_contact_page",
    contact_mode: payload.contactMode || "message",
  };

  try {
    if (asFormData) {
      const formData = new FormData();
      Object.entries(body).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });
      const response = await axiosClient.post(API_ENDPOINTS.CONTACT.SUBMIT, formData, {
        headers: { "Content-Type": "multipart/form-data", Accept: "application/json" },
      });
      const envelope = response?.data?.data ?? response?.data ?? {};
      return {
        status: true,
        message: envelope?.reason || envelope?.message || "Message sent successfully.",
        data: envelope?.data ?? null,
      };
    }

    const response = await axiosClient.post(API_ENDPOINTS.CONTACT.SUBMIT, body);
    const envelope = response?.data?.data ?? response?.data ?? {};
    return {
      status: true,
      message: envelope?.reason || envelope?.message || "Message sent successfully.",
      data: envelope?.data ?? null,
    };
  } catch (error) {
    return {
      status: false,
      message: extractMessage(error, "Unable to send your message. Please try again."),
      data: null,
    };
  }
}
